module.exports = __webpack_public_path__ + "static/media/Metropolis-Regular.efea3d91.ttf";